<div>
    <div class="mb-6 pb-4 border-b-2 border-(--pg-brand-blue)">
        <page-title [title]="'Quick Menu'"></page-title>
    </div>
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-8 w-full">
        @for (item of items(); track $index;){
            @if (item.validPermission) {
                <app-action-card [title]="item.title" [route]="item.route" [icon]="item.icon"></app-action-card>
            }
        } @empty{
            <div class="col-span-4 text-center">No items available</div>
        }
    </div>
    <div class="mt-8">This is a sample menu to be implemented once items and icons are finalized</div>
</div>